import { Button, Flex, Modal, Switch } from "antd";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { setEntityContatoPessoa, setModalCadastrarContatoPessoa, setModalDeletarContatoPessoa } from "../../../redux/slices/contatoPessoa/contatoPessoaSlice";
import { ContatoPessoaModel } from "../../../models/contatoPessoa/contatoPessoaModel";
import { AtivoModel } from "../../../models/ativoModel";
import { atualizarContatoPessoaAtivo, deletarContatoPessoa } from "../../../services/contatoPessoaService";
import { ItemMenuAcoes } from "../../../models/sistema/itemMenuAcoes";
import * as Icon from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import { formatTelefone } from "../../../util/formats";
import AcoesComponent from "../../../components/table/acoesComponent";
import TableComponent from "../../../components/table/tableComponent";
import CadastrarContatoModal from "./modals/cadastrar";
import MensagemModal from "../../../components/modal/mensagem";

dayjs.locale("pt-br");

const ContatoPessoa = () => {
  //estados globais
  const contatoPessoaState = useAppSelector((state) => state.contatoPessoa);
  const pessoaState = useAppSelector((state) => state.pessoa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const editar = Object.values(contatoPessoaState.entity).length !== 0;

  const goCadastrar = () => {
    dispatch(setEntityContatoPessoa({}));
    dispatch(setModalCadastrarContatoPessoa(true));
  };

  const goEditar = (value: ContatoPessoaModel) => {
    dispatch(setEntityContatoPessoa(value));
    dispatch(setModalCadastrarContatoPessoa(true));
  };

  const goDeletar = (value: ContatoPessoaModel) => {
    dispatch(setEntityContatoPessoa(value));
    dispatch(setModalDeletarContatoPessoa(true));
  };

  const closeModalCadastrar = async () => {
    dispatch(setModalCadastrarContatoPessoa(false));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarContatoPessoa(false));
  };

  const onChangeAtivo = (value: ContatoPessoaModel) => {
    const args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarContatoPessoaAtivo({ value: args, busca: pessoaState.entity.id }));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<ContatoPessoaModel> = [
    {
      title: "NOME",
      dataIndex: "nome",
    },
    {
      title: "EMAIL",
      dataIndex: "email",
    },
    {
      title: "DATA DE NASC",
      dataIndex: "dataAniversario",
      align: "center",
      render: (_, record) => {
        return <>{record.dataAniversario && dayjs(record.dataAniversario).format("DD/MM/YYYY")}</>;
      },
    },
    {
      title: "TELEFONE",
      dataIndex: "telefone",
      render: (_, record) => formatTelefone(record.telefone),
    },
    {
      title: "CELULAR",
      dataIndex: "celular",
      render: (_: any, record: any) => formatTelefone(record.celular),
    },
    {
      title: "TIPO CONTATO",
      dataIndex: "idTipoContatoPessoa",
      render: (idTipoContatoPessoa: number) => {
        return <>{contatoPessoaState.listTipo.find((a: any) => a.id === idTipoContatoPessoa)?.denominacao}</>;
      },
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_: any, record: any) => <Switch size="small" checked={record.ativo} onChange={() => onChangeAtivo(record)} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];
  return (
    <Flex gap={24} vertical>
      <Flex justify="end">
        <Button className="addButton buttonPrimary" onClick={goCadastrar} icon={<Icon.PlusCircleOutlined />}>
          CADASTRAR
        </Button>
      </Flex>
      <TableComponent data={contatoPessoaState.list} columns={columns} loading={contatoPessoaState.loading} />
      <Modal
        title={editar ? "EDITAR CONTATO CLIENTE" : "NOVO CONTATO CLIENTE"}
        centered
        width={1150}
        open={contatoPessoaState.modalCadastrar}
        destroyOnHidden
        onCancel={closeModalCadastrar}
        footer={null}
      >
        <CadastrarContatoModal />
      </Modal>
      <Modal title={"REMOVER CONTATO"} centered width={350} open={contatoPessoaState.modalDeletar} destroyOnHidden onCancel={closeModalDeletar} footer={null}>
        <MensagemModal
          text="Deseja remover o contato?"
          action={deletarContatoPessoa({ value: contatoPessoaState.entity.id, busca: pessoaState.entity.id })}
          close={setModalDeletarContatoPessoa(false)}
        />
      </Modal>
    </Flex>
  );
};

export default ContatoPessoa;
